export const lamudiAssetsPath: string = 'https://multimedia.lamudi.com';